(function () {
	function swiperInit() {
		if (typeof subSliderInit === 'function') subSliderInit(true);
		if (typeof sliderInit === 'function') sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
		document.querySelectorAll('.js-media-list').forEach(function (el) {
			if (el.swiper && typeof el.swiper.destroy === 'function') {
				el.swiper.destroy();
			}
		});
		document.querySelectorAll('.js-media-sublist').forEach(function (el) {
			if (el.swiper && typeof el.swiper.destroy === 'function') {
				el.swiper.destroy();
			}
		});

		swiperInit();
	});

	swiperInit();
})();
